<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :span="15">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="SO订单号" prop="salesOrderNo">
                <el-input
                  clearable
                  style="font-size:20px;"
                  v-model="formData.salesOrderNo"
                  placeholder="请输入SO订单号"
                  size="medium"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="批次号" prop="seqNo">
                <el-input
                  readonly
                  style="font-size:16px;"
                  v-model="formData.seqNo"
                  placeholder="系统自动生成"
                  size="medium"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="总件数" prop="totQty" size="small">
                <el-input readonly v-model="totQty"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="总箱数" prop="totBoxNum" size="small">
                <el-input readonly v-model="totBoxNum"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="总计费重（公斤）"
                prop="totPriceWeight"
                size="small"
              >
                <el-input readonly v-model="totPriceWeight"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="总称重重量（公斤）"
                prop="totWeight"
                size="small"
              >
                <el-input readonly v-model="totWeight"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="总体积（立方）"
                prop="totVolume"
                size="small"
              >
                <el-input readonly v-model="totVolume"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="重泡比（公斤/立方米）"
                prop="useTransWeightRatio"
                size="small"
              >
                <el-input readonly v-model="formData.useTransWeightRatio">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="总体积重（公斤）"
                prop="totVolumeWeight"
                size="small"
              >
                <el-input readonly v-model="totVolumeWeight"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9">
          <bill-table
            :tableData.sync="formData.linkbillDetailList"
            :disabled="disabled"
            :totBoxNum="totBoxNum"
          />
        </el-col>
      </el-row>
      <box-table
        @openEditBoxDialog="openEditBoxDialog"
        :disabled="disabled"
        :tableData.sync="formData.weightDetailList"
      />
    </el-form>

    <el-dialog
      v-if="editBoxDialogOptions.visible"
      v-el-dialog-drag
      append-to-body
      visible
      width="600px"
      :title="editBoxDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => closeEditBoxDialog()"
    >
      <input-box
        ref="box"
        :disabled="editBoxDialogOptions.visible"
        :param="editBoxDialogOptions.param"
        :type="editBoxDialogOptions.code"
        :transportMode="transportMode"
      />
      <span slot="footer">
        <el-button size="small" @click="closeEditBoxDialog()">取消</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="editBoxDialogOptions.visible"
          @click="addBoxData()"
          >确认添加</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BillTable from './bill-table'
import BoxTable from './box-table'
import InputBox from './input-box'
import validate from '@/libs/util.validate'
import { add, multiplyRound } from '@/libs/util.number'
export default {
  components: { BillTable, BoxTable, InputBox },
  props: {
    disabled: { type: Boolean, default: () => false },
    waybillWeightCode: { type: String, default: '' },
    waybillCode: { type: String, default: '' },
    transportMode: { type: String, default: '' },
  },
  data() {
    return {
      editBoxDialogOptions: {
        visible: false,
        code: '',
      },
      backDialogVisible: false,
      formData: {
        weightDetailList: [],
        linkbillDetailList: [],
        useTransWeightRatio: '',
        salesOrderNo: '',
        totWeight: '',
        totVolumeWeight: '',
        totQty: '',
        totPriceWeight: '',
        totVolume: '',
      },
      rules: {
        salesOrderNo: [
          {
            required: true,
            message: '请输入SO订单号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    totQty() {
      let count = 0
      this.formData.weightDetailList.forEach((item) => {
        count = add(count, Number(item['packageQty']))
      })
      return count ? count : 0
    },
    totVolume() {
      let count = 0
      this.formData.weightDetailList.forEach((item) => {
        count = add(count, Number(item['subVolume']))
      })
      return count ? count : 0
    },
    totVolumeWeight() {
      return multiplyRound(this.formData.useTransWeightRatio, this.totVolume, 2)
    },
    totPriceWeight() {
      let count = 0
      this.formData.weightDetailList.forEach((item) => {
        count = add(count, Number(item['subPriceWeight']))
      })
      return count ? count : 0
    },
    totBoxNum() {
      let count = 0
      let bill = 0
      this.formData.weightDetailList.forEach((item) => {
        // if (item.packageType == 'A') {
        count = add(count, Number(item['boxQty']))
        // }
        // if (item.packageType == 'B') {
        //   count += multiply(item.packageQty || 0, item.boxQty || 0)
        // }
      })
      this.formData.linkbillDetailList.forEach((item) => {
        bill = add(bill, Number(item['linkBillBoxNum']))
      })
      return count - bill
    },
    totWeight() {
      let count = 0
      this.formData.weightDetailList.forEach((item) => {
        count = add(count, Number(item['subWeight']))
      })
      return count ? count : 0
    },
  },
  methods: {
    getData() {
      this.querySysParams().then((data) => {
        if (this.waybillWeightCode) {
          this.$api
            .bizWaybillWeightDetailApi({
              waybillWeightCode: this.waybillWeightCode,
            })
            .then((res) => {
              this.formData = { ...res.body }
              this.formData.useTransWeightRatio = data
            })
        }
        this.formData.useTransWeightRatio = data
      })
    },
    querySysParams() {
      return this.$api
        .getSysParameterByIdApi({ paramID: 'heavyBubbleRatio' })
        .then((res) => {
          return res.body.paramValue
        })
    },
    openEditBoxDialog({ type, code = '', row = {} }) {
      const types = {
        edit: '编辑',
        add: '新增',
      }
      this.editBoxDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
        param: row,
      }
    },
    closeEditBoxDialog() {
      this.editBoxDialogOptions.visible = false
    },
    addBoxData() {
      this.$refs.box.addBoxData().then((res) => {
        if (!res) return
        for (let i = 0; i < this.formData.weightDetailList.length; i++) {
          if (i === res.index) {
            this.$set(this.formData.weightDetailList, i, res)
            this.closeEditBoxDialog()
            return
          }
        }
        this.formData.weightDetailList.push(res)
        this.closeEditBoxDialog()
      })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.totBoxNum < 0) {
        this.$message.warning(`总箱数不能为负数`)
        return
      }
      this.formData.totQty = this.totQty
      this.formData.totVolume = this.totVolume
      this.formData.totPriceWeight = this.totPriceWeight
      this.formData.totVolumeWeight = this.totVolumeWeight
      this.formData.totBoxNum = this.totBoxNum
      this.formData.totWeight = this.totWeight
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizWaybillWeightSaveApi({
          ...this.formData,
          waybillCode: this.waybillCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.$confirm('是否需要打印称重记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.print(res.body)
            })
            .catch(() => {
              this.$emit('close')
            })
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async print(waybillWeightCode) {
      await this.$api.printPDF('/order/waybill/weight/single/print', {
        waybillCode: this.waybillCode,
        waybillWeightCode,
      })
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
